module.exports = "/_next/static/images/geniusbar-bbcb1f59ff1fca315010fb7883bc6865.png";